export default "__VITE_ASSET__Bpue$_Th__"